<template lang="html">
    <div id="page__additional-services-prices-search" class="toolbar-search">
        <z-select light id="filter_service_id" name="filter_service_id" v-model="filter.service_id">
            <option value="" selected> Услуга (любая) </option>
            <option v-for="item in services" :key="`filter-add-services-prices-item-${item.id}`" v-bind:value="item.id">{{ item.name }}</option>
        </z-select>
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-bind:disabled="!hasFilter" v-on:click="onReset"></z-icon-button>
    </div>
</template>
<script>
    import ClickOutside from 'vue-click-outside';
    import ZIconButton  from '@/components/ZIconButton.vue';
    import ZSelect      from '@/components/ZSelect';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    export default {
        components: {ZIconButton, ZSelect, ZInputAutocomplete},
        directives: {ClickOutside},
        data() {
            return {
                loading: false,
                services: [],
                filter: {
                    service_id: ''
                },
                filterDefault: {
                    service_id: ''
                },
            }
        },
        created() {
            this.getServices();
            this.resolveQueryFilter();
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            },
        },
        watch: {
            'filter.service_id'(newVal, oldVal) {
                if (oldVal != newVal) this.onFilter();
            }
        },
        methods: {
			/**
			 * Получение услуг
			 */
            getServices() {
				return this.$store.dispatch('cost/getAdditionalServices', {
					page: 1,
					order_by: 'id',
					order_type: 'asc',
					count: 'all',
					filter: {model: [
						['active', '=', 1], 'and',
						['type', '=%', 'grid-']
					]},
					nocache: true
				}).then(r => {
					if (!r || !Array.isArray(r)) return [];
					this.services = Object.assign([], r);
					return this.services;
				});
			},
            /**
             * Фильрация
             */
            doFilter() {
                this.$nextTick(() => {
                    let filter = {};
                    Object.keys(this.filter).map(key => {
                        if (this.filter[key]) filter[key] = this.filter[key];
                    });

                    this.$router.push({ name: this.$route.name, params: this.$route.params, query: { filter: JSON.stringify(filter)}});
                    this.$root.$emit('refresh-table', 'additional-services-prices');
                });
            },
            /**
             * Подставлене фильтра при перезагрузки
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            /**
             * Фильтрация
             */
            onFilter() {
                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('refresh-table', 'additional-services-prices');
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query   = Object.assign({}, this.$route.query);
                delete query.filter;
                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query:  Object.assign({}, query)
                });
                this.$root.$emit('refresh-table', 'additional-services-prices');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// AdditionalServicesPricesToolbar.vue?12031102